import React from "react";
export var StopMessageIcon = function StopMessageIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77734 2.77783C3.67277 2.77783 2.77734 3.67326 2.77734 4.77783V13.2223C2.77734 14.3268 3.67277 15.2223 4.77734 15.2223H13.2218C14.3264 15.2223 15.2218 14.3268 15.2218 13.2223V4.77783C15.2218 3.67326 14.3264 2.77783 13.2218 2.77783H4.77734Z",
    fill: "#EF4444"
  }));
};